<script>
  import Grid from './grid'

  export default Grid('container')
</script>

<style lang="stylus" src="../../stylus/components/_grid.styl"></style>



// WEBPACK FOOTER //
// src/components/VGrid/VContainer.vue?cfb0f234